module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_pepiniere-ac2470d34605084b199aa30575441928.png";